// extracted by mini-css-extract-plugin
export default {"container":"Chatting_container__laZZ7","content":"Chatting_content__Gumqw"};